import DiversityInclusion from './DiversityInclusion';

export default DiversityInclusion;
